import React, { memo, useMemo } from "react";
import { Icon } from "components/src/components/Icon/Icon";

const arrowIconMap = {
  top: "icon_ui_triangle_md_up",
  right: "icon_ui_triangle_md_up",
  left: "icon_ui_triangle_md_up",
  bottom: "icon_ui_triangle_md_down",
};

const transformYAxisList = ["top", "bottom"];

export const CalloutArrow = memo(
  ({
    size = 24,
    fill = "status-informational",
    position,
  }: {
    size?: number;
    fill?: string;
    position?: {
      placement?: "top" | "right" | "left" | "bottom";
      xOffset: number;
      yOffset: number;
    };
  }) => {

    const edgeOffset = 6;
    
    const isTransformYAxis = position?.placement && transformYAxisList.includes(position?.placement);
    
    const calculatedPosition = useMemo(() => {
      const _xOffset = isTransformYAxis ? Math.max(position.xOffset - (size / 2) - edgeOffset, 0) : position?.xOffset;
      let _calcPos: React.CSSProperties = {
        transform: position && isTransformYAxis
          ? `translate(${_xOffset}px, ${position.yOffset}px)`
          : `translate(${position?.placement === "left" ? "-" : ""}${position?.yOffset}px, ${_xOffset}px)`,
      };
      if (position?.placement === "top")
        _calcPos = {
          ..._calcPos,
          top: -(size - edgeOffset),
          left: 0,
        };
      if (position?.placement === "left")
        _calcPos = {
          ..._calcPos,
          top: 0,
          left: -(edgeOffset * 3),
          rotate: "-90deg"
        };
      if (position?.placement === "right")
        _calcPos = {
          ..._calcPos,
          top: 0,
          right: -(edgeOffset * 3),
          rotate: "90deg"
        };
      if (position?.placement === "bottom")
        _calcPos = {
          ..._calcPos,
          bottom: -(size - edgeOffset),
          left: 0,
        };
      return _calcPos;
    }, [edgeOffset, position?.placement, position?.xOffset, position?.yOffset]);

    return (
      <Icon
        size={24}
        name={arrowIconMap[position?.placement ?? "top"]}
        color={fill}
        style={{ position: "absolute", ...calculatedPosition }}
      />
    );
  }
);
